import { SxProps, Theme } from '@mui/material';

const detailsContainer: SxProps<Theme> = () => ({
  '@media print': {
    marginTop: 15,
  },
});

const styles = {
  detailsContainer,
};

export default styles;
